<template>
  <div class="grid-wrapper grid grid-cols-6 gap-x-6 gap-y-8 laptop:grid-cols-8">
    <div class="order-1 col-span-6 flex flex-col gap-y-8 laptop:col-span-5 laptop:gap-y-10">
      <h2>{{ data?.companyPage?.data?.attributes?.facilities_title }}</h2>
      <p>
        {{ data?.companyPage?.data?.attributes?.facilities_paragraph_1 }}
      </p>
    </div>
    <div
      class="order-3 col-span-6 laptop:order-2 laptop:col-span-3 laptop:col-start-1 laptop:mt-[280px] desktop:mt-[330px]"
    >
      <ImageStrapi class="w-full" :img="data?.companyPage?.data?.attributes?.facilities_smallImage1" />
      <p class="mt-8">
        {{ data?.companyPage?.data?.attributes?.facilities_paragraph_2 }}
      </p>
    </div>
    <div class="order-2 col-span-6 laptop:order-3 laptop:col-span-5 laptop:col-start-4">
      <ImageStrapi class="w-full" :img="data?.companyPage?.data?.attributes?.facilities_largeImage" />
      <p class="mt-8">
        {{ data?.companyPage?.data?.attributes?.facilities_paragraph_3 }}
      </p>
    </div>
    <div class="order-4 col-span-6 w-full laptop:col-span-5 laptop:mt-0 relative">
      <vue-plyr ref="plyr_bg">
        <div class="plyr__video-embed">
          <iframe
            title="vimeo-player"
            src="https://player.vimeo.com/video/887198775?h=b74b11fb38"
            width="640"
            height="360"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </vue-plyr>
    </div>
    <ImageStrapi
      class="order-5 col-span-6 w-full laptop:col-span-3"
      :img="data?.companyPage?.data?.attributes?.facilities_smallImage2"
    />
    <NextBtn
      class="order-6 col-span-6 col-end-7 justify-end laptop:col-end-9"
      :to="localePath({ name: 'contact' })"
      :text="$t('Contact us')"
    />
  </div>
</template>
<script setup>
import { Companypage2DataKey } from "~/symbols/symbols";

const data = inject(Companypage2DataKey);

const localePath = useLocalePath();
</script>
<style lang="scss" scoped></style>
